import React, { Component } from "react";
import {
  WingBlank,
  Button,
  TextareaItem,
  Toast,
  ImagePicker,
  Checkbox,
} from "antd-mobile";
import { createForm } from "rc-form";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";
import { getBlogs } from "../actions/queries";
import { patientQueryById } from "../actions/mutation";
import styled from "styled-components";
import { createPortal } from "react-dom";
import { getPatientIdFromUrl } from "../../../utils";
import { needleImageCdnStart } from "../../../utils";

function closest(el, selector) {
  const matchesSelector =
    el.matches ||
    el.webkitMatchesSelector ||
    el.mozMatchesSelector ||
    el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class CommentInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      btnLoading: false,
      files: [],
      commentToBottle: false,
      bottleCanUse: true,
    };
    // const rootDom = document.getElementById('root')
    // this.node = window.document.createElement('div')
    // this.rootDom = rootDom
  }

  // componentDidMount() {
  //   window.onload = function () {
  //     document.addEventListener('message', function (event) {
  //       console.log('message====')
  //       // alert("This is a Entry Point Working in android");
  //       // init(event.data)
  //     })
  //   }
  // }

  componentWillReceiveProps(props) {
    console.log("props111", props);
    // if (props.replyType && props.replyType.length > 0) {
    //   this.setState({ visible: props.show })
    // if (this.node.parentNode !== this.rootDom) {
    //   // 避免重复插入节点
    //   this.rootDom.appendChild(this.node)
    // }
    // }
    const blogs = get(props, "blogs");
    if (!blogs.loading && blogs.blogs) {
      const blog = blogs.blogs[0];
      const patientId = getPatientIdFromUrl(this.props);
      const votes = blog.votes;
      if (votes.indexOf(patientId) > -1) {
        this.setState({ blogVote: true });
      } else {
        this.setState({ blogVote: false });
      }
      this.setState({ voteCount: votes.length });
    }
    // 父元素点击事件 清空子元素数据
    if (props.isClean) {
      this.setState({
        files: [],
        bottleCanUse: true,
      });
    }
    const patientQueryById = get(props, "patientQueryById");
    const prePatientQueryById = get(this.props, "patientQueryById");
    if (
      !isEqual(patientQueryById, prePatientQueryById) &&
      !patientQueryById.loading &&
      patientQueryById.patient
    ) {
      this.setState({
        commentToBottle: get(
          props,
          "patientQueryById.patient.commentToBottle",
          false
        ),
      });
    }
  }
  onClose = (key, action) => async (e) => {
    const { setFieldsValue } = this.props.form;
    if (action === "submit") {
      this.handleSubmit(key);
      this.setState({
        btnLoading: true,
      });

      setTimeout(
        (e) =>
          this.setState({
            btnLoading: false,
          }),
        5000
      );
    }
    if (action === "cancel" || !action) {
      this.props.closeCommentInput();

      setFieldsValue({ comment: "" });
      //这个地方有问题，关闭弹窗需要两次
      this.setState({ [key]: false });
      setFieldsValue({ autofocus: "" });
      this.cancelComment();
      // this.rootDom.appendChild(this.node)
    }
  };

  cancelComment = debounce(() => {
    const blogs = get(this.props, "blogs");
    const blog = blogs.blogs[0];
    const blogId = blog._id;
    const patientId = getPatientIdFromUrl(this.props);
    const variables = {
      blogId,
      patientId,
    };
    const mutate = this.props.cancelBlogComment;
    mutate({ variables })
      .then((res) => {
        console.log("mutate then", res);
      })
      .catch((e) => {
        console.log("catch a error", e);
      });
  }, 1500);

  handleSubmit = debounce((key) => {
    let cbResult = true;
    const { getFieldProps, setFieldsValue } = this.props.form;
    const { files } = this.state;
    const { insertBlogComment } = this.props;
    const blogs = get(this.props, "blogs");
    const blog = blogs.blogs[0];
    const blogId = blog._id;
    let commentText = getFieldProps("comment").value || "";
    // if (isEmpty(commentText.replace(/\s*/g, ''))) {
    //   commentText = commentText.replace(/\s*/g, '')
    // } else {
    //   // commentText = commentText.replaceAll(/(\s){2,}/g, '$1')
    //   commentText = commentText.split(/(\s){2,}/g).join(' ')
    // }
    if (isEmpty(commentText) && !files.length > 0) {
      Toast.info("请填写评论内容或者添加图片", 1);
      this.setState({ btnLoading: false });
      return;
    }

    if (!commentText && !files.length > 0) {
      Toast.info("请填写评论内容或者添加图片", 1);
      this.setState({ btnLoading: false });
      return;
    }
    if (commentText && commentText.length > 200) {
      Toast.info("评论内容请控制在200字以内", 1);
      this.setState({ btnLoading: false });
      return;
    }

    this.props.closeCommentInput();

    const type = "comments";
    const patientId = getPatientIdFromUrl(this.props);
    let variables = {};
    let clickId = "";

    if (this.props.replyType && this.props.replyType.length > 0) {
      if (this.props.replyType === "second") {
        clickId = this.props.user.patientId;
      } else {
        clickId = this.props.user._id;
      }
      variables = {
        commentId: this.props._id,
        blogId,
        beReplyedCommentId: this.props._id,
        beReplyedUserId: clickId,
        content: commentText,
        patientId,
        commentType: this.props.replyType,
        replyTools: "H5",
        systemType: "BG",
        imgBase64: files.length > 0 ? files[0].url : null,
        commentToBottle: this.state.commentToBottle,
      };
    } else {
      variables = {
        blogId,
        content: commentText,
        systemType: get(this.props, "match.params.systemType", "BG"),
        patientId,
        imgBase64: files.length > 0 ? files[0].url : null,
        commentToBottle: this.state.commentToBottle,
      };
    }
    console.log("variables: ", variables);
    const mutate = insertBlogComment;
    console.log(
      "handleSubmit variables",
      variables,
      get(this.props, "match.params.knowledgeId")
    );
    if (commentText || files.length > 0) {
      mutate({
        variables,
        refetchQueries: [
          // {
          //   query: getBlogs,
          //   variables: {
          //     blogId: get(this.props, 'match.params.knowledgeId'),
          //     systemType: get(this.props, 'match.params.systemType', 'BG'),
          //   },
          // },
          {
            query: patientQueryById,
            variables: {
              patientId,
            },
          },
        ],
      })
        .then((res) => {
          console.log("mutate then", res);
          this.setState({
            btnLoading: false,
            files: [],
          });
          this.props.blogs.refetch();
          if (res.data.insertBlogComment.commitComment) {
            setFieldsValue({ comment: "" });
            this.setState({ [key]: false, bottleCanUse: true });
            setFieldsValue({ autofocus: "" });
          } else if (res.data.insertBlogComment.sensitiveWords.length > 0) {
            if (
              get(res, "data.insertBlogComment.sensitiveWords.0") === "REPEAT"
            ) {
              Toast.info("已发表相同内容。", 3);
              cbResult = false;
            } else {
              Toast.info("内容中包含不合规信息，请修改", 3);
              cbResult = false;
            }
          } else {
            Toast.info("评论失败，请稍后再试", 3);
            console.log("mutate then", res);
            this.setState({ [key]: false });
            setFieldsValue({ autofocus: "" });
          }
        })
        .catch((e) => {
          console.log("catch a error", e);
          this.setState({ [key]: false });
          setFieldsValue({ autofocus: "" });
        });
    }
  }, 1500);

  blogVoteClick = (action) => {
    this.setState({
      blogVote: !this.state.blogVote,
    });
    if (action == "add") {
      this.setState({
        voteCount: this.state.voteCount + 1,
      });
    } else {
      this.setState({
        voteCount: this.state.voteCount - 1,
      });
    }
    this.handleBlogVote(action);
  };

  handleBlogVote = debounce((action) => {
    console.log("handleBlogVote");
    const blogs = get(this.props, "blogs");
    const blog = blogs.blogs[0];
    const blogId = blog._id;
    const type = "votes";
    const patientId = getPatientIdFromUrl(this.props);
    const systemType = get(this.props, "match.params.systemType", "BG");
    const variables = {
      blogId,
      systemType,
      type,
      patientId,
    };
    console.log("handleBlogVote variables", variables);
    const mutate = this.props.updateBlogVote;
    mutate({ variables })
      .then((res) => {
        console.log("mutate then", res);
      })
      .catch((e) => {
        console.log("catch a error", e);
      });
  }, 1500);

  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };
  handleClick = () => {
    this.autoFocusInst.focus();
    console.log("--->");
  };

  onChange = (files, type, index) => {
    this.setState({
      files,
      // bottleCanUse: false,
      // commentToBottle: false
    });
    // 子元素改变父元素字段状态
    this.props.handleFlag();
  };
  onTabChange = (key) => {
    console.log(key);
  };
  handlePermission = () => {
    window.postMessage("checkCameraPermission");
  };
  handleToBottle = (e, isTourist) => {
    if (isTourist) {
      Toast.info("同步功能仅共同照护用户开放", 1);
    } else {
      this.setState({ commentToBottle: get(e, "target.checked") });
    }
  };

  render() {
    const { getFieldProps } = this.props.form;
    const { btnLoading, files } = this.state;
    const screenBottom = get(this.props, "isBigScreen") ? 34 : 0;
    const commentText = getFieldProps("comment").value;
    const addImage = get(
      this.props,
      "appVision.getUserAppVision.showImage",
      false
    );
    const isTourist = get(
      this.props,
      "appVision.getUserAppVision.isTourist",
      false
    );

    let isBtn =
      btnLoading ||
      !{ ...getFieldProps("comment") } ||
      (isEmpty(commentText && commentText.replace(/\s*/g, "")) &&
        !files.length);
    return (
      // createPortal(
      <RootView onClick={this.onClose("visible")}>
        {addImage ? (
          <ContentViews
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <InputListItems
              autoFocus
              {...getFieldProps("comment")}
              rows={3}
              count={200}
              placeholder="您想说点什么…"
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ flex: 1 }}>
                {addImage && (
                  <ImagePicker
                    files={files}
                    onChange={this.onChange}
                    disableDelete
                    onImageClick={(index, fs) => {
                      this.props.showModal(fs[0].url);
                    }}
                    selectable={files.length < 1}
                    multiple={false}
                    onAddImageClick={this.handlePermission}
                  />
                )}
              </div>
              <ButtonViews>
                <Checkbox
                  style={{ marginRight: "auto" }}
                  disabled={!this.state.bottleCanUse}
                  checked={this.state.commentToBottle}
                  onChange={(e) => this.handleToBottle(e, isTourist)}
                >
                  同步至说一说
                </Checkbox>
                <div className="btnBox">
                  <Button
                    className="btn"
                    inline
                    size="small"
                    onClick={this.onClose("visible", "submit")}
                    disabled={isBtn}
                    loading={btnLoading}
                    style={{
                      background: isBtn ? "#EEEEEE" : "rgba(38, 197, 171, 1)",
                      border: "0px",
                      color: isBtn ? "#999" : "#FFF",
                    }}
                  >
                    发送
                  </Button>
                </div>
              </ButtonViews>
            </div>
          </ContentViews>
        ) : (
          <ContentView
            onClick={(e) => {
              // e.preventDefault();
              e.stopPropagation();
            }}
          >
            <InputListItem
              autoFocus
              {...getFieldProps("comment")}
              rows={3}
              count={200}
              placeholder="您想说点什么…"
            />
            <ButtonView
              inline
              size="small"
              onClick={this.onClose("visible", "submit")}
              disabled={btnLoading || !{ ...getFieldProps("comment") }}
              loading={btnLoading}
            >
              发送
            </ButtonView>
          </ContentView>
        )}
      </RootView>
      // this.node
    );
  }
}

const FixedDiv = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  .am-image-picker-list {
    padding: 0px;
  }
  .am-image-picker-list .am-image-picker-upload-btn:after {
    width: 10px !important;
  }
  .am-image-picker-list .am-image-picker-upload-btn:before{
    height: 10px !important;
  }
`;

const RootView = styled(FixedDiv)`
  background-color: rgba(0, 0, 0, 0.8);
  overflow: auto;
  outline: 0;
  .am-button::before {
    content: ""; // 添加 content 属性
    border: 2px solid red;
  }
`;

const ContentViews = styled.div`
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  .am-list-item {
    background: rgba(248, 247, 248, 1);
    padding-left: 0px !important;
    padding-bottom: 0px !important;
    border-radius: 5px;
  }
  position: absolute;
  bottom: 0px;
  background: rgba(255, 255, 255, 1);
  width: 100%;
  .am-image-picker-item-remove {
    display: none;
  }
  .am-textarea-count {
    margin-right: 5px !important;
    margin-bottom: 5px !important;
  }
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
const ContentView = styled.div`
  display: flex;
  align-items: center;
  .am-list-item {
    background: rgba(248, 247, 248, 1);
    padding-left: 5px !important;
    padding-bottom: 0px !important;
    border-radius: 5px;
  }
  position: absolute;
  bottom: 0px;
  background: rgba(255, 255, 255, 1);
  width: 100%;
`;

const InputView = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #ffffff;
  border-top: 1px solid rgba(234, 234, 234, 1);
  padding: 15px;
  .input-container {
    position: relative;
    background: #f5f6f8;
    padding: 10px;
    border-radius: 5px;
    color: rgba(153, 153, 153, 1);
  }
`;

const InputViews = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #ffffff;
  border-top: 1px solid rgba(234, 234, 234, 1);
  padding: 15px;
  .input-container {
    position: relative;
    background: rgba(234, 234, 234, 1);
    padding: 10px;
    border-radius: 5px;
    color: rgba(153, 153, 153, 1);
  }
`;
const InputListItems = styled(TextareaItem)`
  flex: 1;
  margin: 10px auto;
  padding: 0px;
  .am-textarea-control {
    padding: 10px;
    background: rgba(245, 246, 248, 1);
    textarea {
      color: rgba(51, 51, 51, 1);
      font-size: 16px;
    }
  }
`;

const InputListItem = styled(TextareaItem)`
  flex: 1;
  margin: 10px;
  padding: 5px;
  .am-textarea-control {
    padding: 0px;
    background: rgba(245, 246, 248, 1);
    textarea {
      color: rgba(51, 51, 51, 1);
      font-size: 16px;
    }
  }
`;
const ButtonViews = styled.div`
  flex: 1.2;
  position: relative;
  .am-checkbox.am-checkbox .am-checkbox-inner {
    right: 5px;
  }
  .am-checkbox.am-checkbox-checked .am-checkbox-inner {
    right: 5px;
    border-color: rgba(38, 197, 171, 1);
    background: rgba(38, 197, 171, 1);
  }
  .btnBox {
    position: absolute;
    top: 50%;
    right: 0px;
    width: 80px;
    height: 30px;
    margin-top: -15px;
    margin-left: 20px;
    border-width: 0px;
    .btn {
      width: 80px;
      hegiht: 32px;
      border-radius: 16px;
      border: 0px solid #eee !important;
    }
  }
`;
const ButtonView = styled(Button)`
  margin-right: 10px;
  background: rgba(38, 197, 171, 1) !important;
  span {
    color: #ffffff;
  }
`;
export default createForm()(CommentInput);
// background: rgba(38, 197, 171, 1) !important;



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/commentInput.js